module.exports = "Please provide a link by forking these links [antd](https://codesandbox.io/s/2wpk21kzvr) or GitHub repo.\n<br>\n[What is a minimal reproduction, and why is it required?](#repro-modal)\n"


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/en/reproHelp.md
// module id = 496
// module chunks = 0